import React from 'react';
import StringBuilder from "../utils/StringBuilder";
var DataTestIdBuilderContext = /*#__PURE__*/React.createContext(StringBuilder.create());
export default DataTestIdBuilderContext;